module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.payers && _vm.$props.payerId) ? _c('div', {
    staticClass: "full-price"
  }, [_vm._l((_vm.payers), function(payer, i) {
    return (_vm.resPayerPrice(payer.id) || parseInt(payer.id) === parseInt(_vm.$props.payerId)) ? _c('div', {
      staticClass: "payer-price-item",
      class: {
        'even': (i % 2 == 0), 'odd': (i % 2 != 0)
      }
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_c('b', [_vm._v(_vm._s(payer.name))])]), _vm._v(" "), (parseInt(payer.id) === parseInt(_vm.$props.payerId)) ? [_c('div', {
      staticClass: "full-price__item"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v(_vm._s(((parseInt(_vm.deal.first_freight.doom) === 1) ? 'Цена перевозки (с учётом обрешётки)' : 'Цена перевозки')))]), _vm._v(" "), (_vm.canEditPrice) ? _c('div', {
      staticClass: "full-price__item-edit"
    }, [(parseInt(_vm.deal.first_freight.full_price.manual) === 1) ? _c('md-button', {
      staticClass: "md-icon-button md-dense close small fill-price__item-edit-btn",
      on: {
        "click": function($event) {
          _vm.manualDeleteOpen('default', 'Цена перевозки')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    }), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "top",
        "md-delay": "500"
      }
    }, [_vm._v("Установить расчетную цену")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-dense close small fill-price__item-edit-btn",
      on: {
        "click": function($event) {
          _vm.manualEditOpen('default', _vm.deal.first_freight.full_price.default, 'Цена перевозки')
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-pen"
    }), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "top",
        "md-delay": "500"
      }
    }, [_vm._v("Изменить")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "full-price__item-value"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.deal.first_freight.full_price.default) + ' руб.'))])]), _vm._v(" "), (_vm.deal.first_freight.full_price.markup > 0) ? _c('div', {
      staticClass: "full-price__item"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v("Наценка")]), _vm._v(" "), _c('div', {
      staticClass: "full-price__item-value"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.deal.first_freight.full_price.markup) + ' руб.'))])]) : _vm._e(), _vm._v(" "), (_vm.deal.first_freight.full_price.discount > 0) ? _c('div', {
      staticClass: "full-price__item"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v("Скидка")]), _vm._v(" "), _c('div', {
      staticClass: "full-price__item-value"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.deal.first_freight.full_price.discount) + ' руб.'))])]) : _vm._e(), _vm._v(" "), _vm._m(0, true), _vm._v(" "), (_vm.deal.first_freight.full_price.additional_services && Object.values(_vm.deal.first_freight.full_price.additional_services)) ? _vm._l((Object.values(_vm.deal.first_freight.full_price.additional_services)), function(item) {
      return (item.value > 0) ? _c('div', {
        staticClass: "full-price__item"
      }, [_c('div', {
        staticClass: "full-price__item-title"
      }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
        staticClass: "full-price__item-value"
      }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.value) + ' руб.'))])]) : _vm._e()
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.deal.first_freight.full_price.additional && Object.values(_vm.deal.first_freight.full_price.additional)) ? _vm._l((Object.entries(_vm.deal.first_freight.full_price.additional)), function(ref) {
      var code = ref[0];
      var item = ref[1];

      return ((item.value > 0 || (item.value <= 0 && parseInt(item.manual) === 1)) && (parseInt(item.payer_id) === parseInt(payer.id) || !item.payer_id)) ? _c('div', {
        staticClass: "full-price__item"
      }, [_c('div', {
        staticClass: "full-price__item-title"
      }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), (_vm.canEditPrice) ? _c('div', {
        staticClass: "full-price__item-edit"
      }, [(parseInt(item.manual) === 1) ? _c('md-button', {
        staticClass: "md-icon-button md-dense close small fill-price__item-edit-btn",
        on: {
          "click": function($event) {
            _vm.manualDeleteOpen(code, item.label)
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-trash"
      }), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "top",
          "md-delay": "500"
        }
      }, [_vm._v("Установить расчетную цену")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
        staticClass: "md-icon-button md-dense close small fill-price__item-edit-btn",
        on: {
          "click": function($event) {
            _vm.manualEditOpen(code, item.value, item.label)
          }
        }
      }, [_c('i', {
        staticClass: "fas fa-pen"
      }), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "top",
          "md-delay": "500"
        }
      }, [_vm._v("Изменить")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "full-price__item-value"
      }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.value) + ' руб.'))])]) : _vm._e()
    }) : _vm._e(), _vm._v(" "), (_vm.resPayerPrice(payer.id)) ? _c('div', {
      staticClass: "full-price__item"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v("НДС")]), _vm._v(" "), _c('div', {
      staticClass: "full-price__item-value"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.resPayerPrice(payer.id)['nds']) + ' руб.'))])]) : _vm._e(), _vm._v(" "), (_vm.resPayerPrice(payer.id)) ? _c('div', {
      staticClass: "full-price__item"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v("Цена без НДС")]), _vm._v(" "), _c('div', {
      staticClass: "full-price__item-value"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.resPayerPrice(payer.id)['without_nds']) + ' руб.'))])]) : _vm._e(), _vm._v(" "), (_vm.resPayerPrice(payer.id)) ? _c('div', {
      staticClass: "full-price__item result"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v("Итого")]), _vm._v(" "), _c('div', {
      staticClass: "full-price__item-value"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.resPayerPrice(payer.id)['result']) + ' руб.'))])]) : _vm._e()], 2) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "payer-price-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "full-price__item"
  }, [_c('div', {
    staticClass: "full-price__item-title"
  }, [_vm._v("НДС")]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item-value"
  }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.deal.first_freight.full_price.nds) + ' руб.'))])]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item"
  }, [_c('div', {
    staticClass: "full-price__item-title"
  }, [_vm._v("Цена без НДС")]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item-value"
  }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.deal.first_freight.full_price.without_nds) + ' руб.'))])]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item result"
  }, [_c('div', {
    staticClass: "full-price__item-title"
  }, [_vm._v("Итого")]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item-value"
  }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.deal.first_freight.full_price.result) + ' руб.'))])])]), _vm._v(" "), _c('div', {
    staticClass: "payer-price-item"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "full-price__item-title storate"
  }, [_c('b', [_vm._v("Хранение груза")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-dense close small storage-btn recalc",
    attrs: {
      "disabled": _vm.blocked
    },
    on: {
      "click": _vm.recalc
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top",
      "md-delay": "500"
    }
  }, [_vm._v("Обновить срок, стоимость хранения и связанные документы")])], 1)], 1), _vm._v(" "), (_vm.$props.storage && _vm.$props.storage.list.length) ? _c('div', [_vm._l((_vm.$props.storage.list), function(store) {
    return _c('div', {
      staticClass: "full-price__item"
    }, [_c('div', {
      staticClass: "full-price__item-title"
    }, [_vm._v(_vm._s(store.stock.name))]), _vm._v(" "), (store.storage_error) ? _c('div', {
      staticClass: "full-price__item-value"
    }, [_c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(store.storage_error))])]) : _c('div', {
      staticClass: "full-price__item-value"
    }, [(store.to_today) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("✸")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(store.storage_time_display))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(' (' + _vm.moment(store.from_date).tz(_vm.$root.userTimezone).format('DD.MM.YYYY') + ' - ' + _vm.moment(store.to_date).tz(_vm.$root.userTimezone).format('DD.MM.YYYY') + ')'))])]), _vm._v(" "), (store.to_today) ? _c('md-tooltip', {
      attrs: {
        "md-direction": "top",
        "md-delay": "500"
      }
    }, [_vm._v("\n                    Отстутствует трекинг выдачи получателю. Расчёт до текущей даты на складе назначения.\n                ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.$props.storage && _vm.$props.storage.total && _vm.$props.storage.total.display) ? _c('div', {
    staticClass: "full-price__item result"
  }, [_c('div', {
    staticClass: "full-price__item-title"
  }, [_vm._v("Итого")]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item-value"
  }, [_vm._v(_vm._s(_vm.$props.storage.total.display))])]) : _vm._e(), _vm._v(" "), (_vm.$props.freight && _vm.$props.freight.storage_time_service) ? _c('div', {
    staticClass: "full-price__item result"
  }, [_c('div', {
    staticClass: "full-price__item-title"
  }, [_vm._v("Сверхнормативное хранение (с учётом нерабочих дней)")]), _vm._v(" "), _c('div', {
    staticClass: "full-price__item-value"
  }, [_vm._v(_vm._s(((_vm.$props.freight.storage_time_service) + " дн.")))])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.manualEditForm.active
    },
    on: {
      "close": _vm.manualEditCancel
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(("Изменение стоимости услуги \"" + (_vm.manualEditForm.label) + "\"")) + "\n        ")]), _vm._v(" "), _c('template', {
    slot: "default"
  }, [_c('z-input', {
    attrs: {
      "error": _vm.manualEditForm.error,
      "label": "Укажите стоимость",
      "type": "number",
      "placeholder": "000.00"
    },
    model: {
      value: (_vm.manualEditForm.value),
      callback: function($$v) {
        _vm.$set(_vm.manualEditForm, "value", $$v)
      },
      expression: "manualEditForm.value"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('ZButton', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.manualEditCancel
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('ZButton', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.manualEditSave
    }
  }, [_vm._v("Сохранить")])], 1)], 2), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.manualDeleteForm.active
    },
    on: {
      "close": _vm.manualDeleteCancel
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n            " + _vm._s(("Установить расчетную стоимость для услуги \"" + (_vm.manualDeleteForm.label) + "\"")) + "\n        ")]), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('ZButton', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.manualDeleteCancel
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('ZButton', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.manualDeleteSave
    }
  }, [_vm._v("Сохранить")])], 1)], 2)], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-price__item"
  }, [_c('div', {
    staticClass: "full-price__item-title"
  }, [_c('b', [_vm._v("Дополнительные услуги")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-price__item-title"
  }, [_c('b', [_vm._v("Итоговая цена по заявке")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442a2374","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/PriceList.vue
// module id = 1119
// module chunks = 0